import { render, staticRenderFns } from "./LabelInter.vue?vue&type=template&id=51b9c9a2&"
import script from "./LabelInter.vue?vue&type=script&lang=js&"
export * from "./LabelInter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports